module.exports = __webpack_public_path__ + "static/media/TradingRange.0ca087c8.PNG";